import axios from 'axios'

export default class {
  _serviceUrl
  _signinUrl
  _signupUrl
  _additionalConfig
  constructor() {
    this._serviceUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_USERS_OPERATION}`
    this._signinUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_SIGNIN_OPERATION}`
    this._signinIdentityUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_SIGNIN_IDENTITY}`
    this._signupUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_SIGNUP_OPERATION}`
    this._additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      }
    }
  }

  signin(credentials) {
    return axios.post(this._signinUrl, credentials, this._additionalConfig)
  }

  signinIdentity(token) {
    return axios.post(this._signinIdentityUrl, token, this._additionalConfig)
  }

  signup(data) {
    return axios.post(this._signupUrl, data, this._additionalConfig)
  }

  editAccount(id, usrData) {
    return axios.put(`${this._serviceUrl}/${id}`, usrData)
  }

  getAccount(id) {
    return axios.get(`${this._serviceUrl}/${id}`)
  }

  checkIdentityAccount(code) {
    let data = `grant_type=authorization_code&`
    data += `client_id=${process.env.VUE_APP_IDENTIDADES_CLIENT_ID}&`
    data += `client_secret=${process.env.VUE_APP_IDENTIDADES_CLIENT_ST}&`
    data += `code=${code}`
    
    return axios.post(
        `${process.env.VUE_APP_IDENTIDADES_URL}/${process.env.VUE_APP_IDENTIDADES_TOKEN}`, 
        data,
        {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
      )
  }
}
